import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";

const STEPS = [FirstStep, SecondStep, ThirdStep];

export default STEPS;
